module.exports = __webpack_public_path__ + "img/744.b4e03758.jpg";